import { PRIVACY_URL, REDIRECT_KEY_STORAGE } from '@constants';
import useAuth from '@contexts/AuthProvider';
import { Alert, Button, Divider, Link, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import useTheme from '~/theme/ThemeProvider';
import { resolveUrl } from '~/utils/urlUtils';

export default function AlreadyAuthenticated() {
  const { tokenParsed, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { colors } = useTheme();

  const handleSwitchAccount = async () => {
    sessionStorage.setItem(REDIRECT_KEY_STORAGE, '/auth');
    try {
      await logout({ logoutMethod: 'POST', redirectUri: `${window.location.origin}/oauth` });
    } catch {
      await logout({ logoutMethod: 'GET', redirectUri: `${window.location.origin}/oauth` });
    }
  };

  return (
    <>
      <Stack sx={{ gap: 1, width: '100%' }}>
        <Typography>
          <Trans i18nKey="registration.alreadySignedIn" />
        </Typography>
        <Alert
          sx={{
            border: 'none',
            justifyContent: 'center',
            backgroundColor: colors.BACKGROUNDS.SUBTLE,
            '& .MuiAlert-message': { overflow: 'hidden' },
            width: '100% !important',
          }}
          data-test-id="already-authenticated-email"
        >
          <Typography noWrap sx={{ fontWeight: 600 }}>
            {tokenParsed?.email}
          </Typography>
        </Alert>
      </Stack>
      <Typography sx={{ textAlign: 'center' }}>
        <Trans i18nKey="registration.consent.privacyPolicy">
          <Link href={resolveUrl(PRIVACY_URL)} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline' }} />
        </Trans>
      </Typography>
      <Stack sx={{ gap: 4, width: '100%' }}>
        <Button onClick={() => void navigate('/redeem')} data-test-id="already-authenticated-next-button">
          <Trans i18nKey="common.actions.next" />
        </Button>
        <Divider>
          <Typography>
            <Trans i18nKey="common.or" />
          </Typography>
        </Divider>
        <Stack direction="row" sx={{ spacing: 1, width: '100%', justifyContent: 'start' }}>
          <Typography>
            <Trans i18nKey="registration.actions.switchAccount" />
          </Typography>
          <Link
            component="button"
            onClick={() => void handleSwitchAccount()}
            sx={{ fontWeight: 900 }}
            aria-label={t('registration.actions.switchAccount')}
            role="link"
            data-test-id="already-authenticated-switch-account-button"
          >
            <Trans i18nKey="registration.actions.login" />
          </Link>
        </Stack>
      </Stack>
    </>
  );
}
